/**
 * Makes a mocked react-query `mutate` settle the way react-query does:
 * onSuccess or onError, then onSettled.
 * use for jest testing
 */
export const mockMutateSettles = (
  mutate: jest.Mock,
  { data, error }: { data?: unknown; error?: Error },
) =>
  mutate.mockImplementation((_variables, options) => {
    if (error) {
      options.onError(error);
    } else {
      options.onSuccess(data);
    }
    options.onSettled(data, error ?? null);
  });
